__turbopack_context__.v({
  "active": "style-module-scss-module__tYc2LG__active",
  "component": "style-module-scss-module__tYc2LG__component",
  "nib": "style-module-scss-module__tYc2LG__nib",
  "price-pin": "style-module-scss-module__tYc2LG__price-pin",
  "size-1": "style-module-scss-module__tYc2LG__size-1",
  "size-2": "style-module-scss-module__tYc2LG__size-2",
  "size-3": "style-module-scss-module__tYc2LG__size-3",
  "visited": "style-module-scss-module__tYc2LG__visited",
});
